export default "__VITE_ASSET__CKlfgSH8__"